import { useParams } from 'react-router-dom'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetLeadDetailOnMount } from '@user/store/lead'
import { useGetOpportunityDetailOnMount } from '@user/store/opportunity'

export function useGetDetailOnMount(entityType: ENTITY_TYPES) {
  const { id } = useParams<{ id: string }>()
  const hook =
    entityType === ENTITY_TYPES.Lead
      ? useGetLeadDetailOnMount
      : useGetOpportunityDetailOnMount

  return hook(Number(id))
}
